// TODO: <
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// TODO: >

import { BigNumber } from '@ethersproject/bignumber';
import { useCallback, useMemo, useState } from 'react';
import { useTransactionAdder } from 'store/transactions/hooks';
import useTarotRouter, { useDoUpdate } from './useTarotRouter';
import { ButtonState } from '../components/InteractionButton';
import { formatUnits } from '@ethersproject/units';

export default function useTowerUnstake(towerPoolAddress: string, amount: BigNumber, decimals: BigNumber, invalidInput: boolean): [ButtonState, () => Promise<void>] {
  const tarotRouter = useTarotRouter();
  const doUpdate = useDoUpdate();
  const addTransaction = useTransactionAdder();
  const [pending, setPending] = useState<boolean>(false);

  const summary = `Unstake ${formatUnits(amount, decimals)} bTAROT from The Tower`;

  const towerUnstakeState: ButtonState = useMemo(() => {
    if (invalidInput) return ButtonState.Disabled;
    if (pending) return ButtonState.Pending;
    return ButtonState.Ready;
  }, [pending, amount, towerPoolAddress]);

  const towerUnstake = useCallback(async (): Promise<void> => {
    if (towerUnstakeState !== ButtonState.Ready) return;
    setPending(true);
    try {
      await tarotRouter.towerUnstake(amount, towerPoolAddress, (hash: string) => {
        addTransaction({ hash }, { summary });
      });
      doUpdate();
    } finally {
      setPending(false);
    }
  }, [addTransaction, amount, towerPoolAddress, decimals]);

  return [towerUnstakeState, towerUnstake];
}
